import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navigation.css";
import logo from "../../assets/logo.png";
import NotificationBell from "../NotificationBell/NotificationBell";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Our Values", href: "/ourvalues" },
  { label: "Onboarding", href: "/onboarding" },
  // { label: "QMS", href: "/qms" },
  { label: "What’s Happening", href: "/whats-happening" },
  { label: "Directory", href: "/directory" },
  { label: "Forms", href: "/forms" },
  { label: "Vacancies", href: "/vacancies" },
  { label: "Our Parks", href: "/ourparks" },
  { label: "Employee Wellbeing", href: "/employeebenefits" },
  // { label: "Suggestions", href: "/suggestions" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const getActiveLabel = (pathname) => {
    const normalized = pathname.toLowerCase();

    const match = navLinks.find((link) =>
      link.href === "/"
        ? normalized === "/"
        : normalized.startsWith(link.href.toLowerCase())
    );

    return match ? match.label : "";
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  /*
    Scroll lock while the mobile menu is open.

    This prevents the page from scrolling behind the mobile menu,
    including on iOS Safari.
  */
  useEffect(() => {
    if (!menuOpen) return;

    const scrollY = window.scrollY;
    const { style } = document.body;

    const prev = {
      position: style.position,
      top: style.top,
      left: style.left,
      right: style.right,
      width: style.width,
    };

    style.position = "fixed";
    style.top = `-${scrollY}px`;
    style.left = "0";
    style.right = "0";
    style.width = "100%";

    return () => {
      style.position = prev.position;
      style.top = prev.top;
      style.left = prev.left;
      style.right = prev.right;
      style.width = prev.width;

      window.scrollTo(0, scrollY);
    };
  }, [menuOpen]);

  const activeLink = getActiveLabel(location.pathname);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    navigate(href);
  };

  return (
    <>
      <nav
        className={`navbar ${scrolled ? "scrolled" : ""} ${
          menuOpen ? "menu-open" : ""
        }`}
      >
        {/* Logo */}
        <a
          href="/"
          className="logo"
          onClick={(e) => handleNavClick(e, "/")}
        >
          <img
            className="logo-img"
            alt="Company Logo"
            src={logo}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </a>

        {/* Desktop Navigation */}
        <ul className="nav-links">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className={activeLink === link.label ? "active" : ""}
                onClick={(e) => handleNavClick(e, link.href)}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Right Side */}
        <div className="nav-right">
          <NotificationBell />

          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            type="button"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile Navigation */}
      {createPortal(
        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <ul>
            {navLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className={activeLink === link.label ? "active" : ""}
                  onClick={(e) => {
                    handleNavClick(e, link.href);
                    setMenuOpen(false);
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>,
        document.body
      )}
    </>
  );
}